var React = require('react');

function SocialInstagram (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z","fill":"currentColor","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8.24925 3H15.7493C18.6442 3 21 5.355 21 8.24925V15.7493C21 18.6442 18.645 21 15.7507 21H8.25075C5.35575 21 3 18.645 3 15.7507V8.25075C3 5.35575 5.355 3 8.24925 3ZM7.5 12C7.5 14.4818 9.51825 16.5 12 16.5C14.4818 16.5 16.5 14.4818 16.5 12C16.5 9.51825 14.4818 7.5 12 7.5C9.51825 7.5 7.5 9.51825 7.5 12ZM16.5 6.75C16.5 7.164 16.836 7.5 17.25 7.5C17.664 7.5 18 7.164 18 6.75C18 6.336 17.664 6 17.25 6C16.836 6 16.5 6.336 16.5 6.75Z","fill":"currentColor","key":1})]);
}

SocialInstagram.defaultProps = {"viewBox":"0 0 24 24","fill":"none"};

module.exports = SocialInstagram;

SocialInstagram.default = SocialInstagram;
